import { render, staticRenderFns } from "./RootPage.vue?vue&type=template&id=4d6fd0e4"
var script = {}
import style0 from "./RootPage.vue?vue&type=style&index=0&id=4d6fd0e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports